import { Modal } from 'antd';

export default function FinanceDetailModal({ open, title, onClose, width = 860, children }) {
  return (
    <Modal open={open} title={title} onCancel={onClose} footer={null} width={width} destroyOnClose>
      {children}
    </Modal>
  );
}
